<template>
  <table class="tb-row">
    <colgroup>
      <col style="width:25%;" />
      <col style="width:auto;" />
    </colgroup>
    <tbody>
    <tr>
      <th>현재 비밀번호</th>
      <td class="last">
        <input type="password" style="width: 100%;"
               maxlength="15"
               v-model="nowMberPswd"/>
      </td>
    </tr>
    <tr>
      <th>새 비밀번호</th>
      <td class="last">
        <input type="password" style="width: 100%;"
               maxlength="15"
               v-model="mberPswd"/>
      </td>
    </tr>
    <tr>
      <th>비밀번호 확인</th>
      <td class="last">
        <input type="password" style="width: 100%;"
               maxlength="15"
               v-model="mberPswdCnfm"/>
      </td>
    </tr>
    </tbody>
  </table>
  <div class="info-txt-bottom">
    <p class="info1">비밀번호는 <span class="pc01">8-15자리의 영문/숫자/특수문자</span>를 함께 입력해주세요.</p>
  </div>
  <div class="layer-btn">
    <btn :txt="'취소'"
         :color="'white'"
         @click="btnCancl_click"/>
    <btn :txt="'변경'"
         :color="'purple'"
         @click="btnChng_click"/>
  </div>
</template>

<script setup>
import {defineEmits, defineProps, ref} from "vue";

import {getUtils, getStore} from "@/utils/import";
const {$alert, $valid, $axios, $cmmn} = getUtils();
const {$loading} = getStore();

const props = defineProps({
  mberSn: {
    type: Number,
    required: true
  },
})

const nowMberPswd = ref('');
const mberPswd = ref('');
const mberPswdCnfm = ref('');

const valid = () => {
  let isValid = true;
  let msg = '';

  const isInputNowMberPswd = nowMberPswd.value;
  if (isValid && !isInputNowMberPswd) {
    isValid = false;
    msg = '현재 비밀번호를 입력해주세요.';
  }

  const isInputMberPswd = mberPswd.value;
  if (isValid && !isInputMberPswd) {
    isValid = false;
    msg = '새 비밀번호를 입력해주세요.';
  }

  const isInputMberPswdCnfm = mberPswdCnfm.value;
  if (isValid && !isInputMberPswdCnfm) {
    isValid = false;
    msg = '비밀번호 확인을 입력해주세요.';
  }

  const isSuitMberPswd = $valid.pswd(mberPswd.value);
  if (isValid && !isSuitMberPswd) {
    isValid = false;
    msg = '비밀번호는 8-15자리의 영문/숫자/특수문자를 함께 입력해주세요.';
  }

  const isSameMberPswdCnfm = mberPswd.value == mberPswdCnfm.value;
  if (isValid && !isSameMberPswdCnfm) {
    isValid = false;
    msg = '새 비밀번호와 비밀번호 확인이 일치하지 않습니다. <br/>다시 확인해주세요.';
  }

  return {isValid, msg};
}

const btnChng_click = async () => {
  try {
    $loading.on();

    const {isValid, msg} = valid();

    if (!isValid) {
      await $alert(msg);
      return false;
    }


    const cnfmPswdParams = {
      mberSn: props.mberSn,
      nowMberPswd: nowMberPswd.value,
      newMberPswd: mberPswd.value
    };

    await getIsCnfmMberPswd(cnfmPswdParams);
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const getIsCnfmMberPswd = async ({mberSn, nowMberPswd, newMberPswd}) => {
  const {data: code}
          = await $axios.get('/api/mber/is-cnfm-mber-pswd', {params: {mberSn, nowMberPswd, newMberPswd}});

  if (code != '000') {
    let msg = '현재 비밀번호가 일치하지 않습니다.';
    if (code == '900') msg = '새 비밀번호는 현재 비밀번호와 동일하게 변경 불가합니다.';

    await $alert(msg);
    return false;
  }

  await modifyMberPswd({mberSn, mberPswd: newMberPswd});
}

const modifyMberPswd = async ({mberSn, mberPswd}) => {
  const {data: modifyCnt} = await $axios.post('/api/mber/mber-pswd', {mberSn, mberPswd});

  if (modifyCnt == 0) {
    await $alert('오류가 발생하였습니다. 다시 시도해주세요.');
    return false;
  }

  await $alert('변경되었습니다.');
  close();
}

const emits = defineEmits(['close']);
const btnCancl_click = () => {
  close();
}

const close = () => {
  emits('close');
}

</script>

<style scoped>

</style>
